import React from 'react';

import styles from './firmReferencesReorderFormStyles';

import ReorderForm from 'buyside/components/presentation/Form/ReorderForm/reorderForm';

const renderFirmReference = firmReference => (
  <div className={styles.firmReference}>
    <strong>{firmReference.name}</strong>
    <span>{firmReference.employer}</span>
  </div>
);

const FirmReferencesReorderForm = ({ ...props }) => {
  return (
    <ReorderForm attr="fundProfile.firmReferences" renderItem={renderFirmReference} {...props} />
  );
};

export default FirmReferencesReorderForm;
